<template>
  <div id="Pricing4" class="pricing101-pricing10 thq-section-padding">
    <div class="pricing101-max-width thq-section-max-width">
      <div class="pricing101-section-title">
        <span class="cssTextAlignCenter thq-body-small">
          <div class="cssContents">
            <span class="cssInlineBlock"></span>
          </div>
        </span>
        <div class="pricing101-content1">
          <h2 class="cssTextAlignCenter thq-heading-2">
            <div class="cssContents">
              <span class="cssInlineBlock">{{ $t('text59') }}</span>
            </div>
          </h2>
          <div class="cssTextAlignCenter thq-body-large">
            <div class="cssContents">
              <span class="cssInlineBlock">{{ $t('text60') }}</span>
            </div>
          </div>
        </div>
      </div>


      <div class="pricing101-content2">
        <div class="pricing101-column1 thq-card">
          <div class="pricing101-content3">
            <div class="pricing101-price1">
              <div class="cssFontStyleNormal cssTextAlignCenter thq-body-large">
                <div class="cssContents">
                  <span class="cssInlineBlock"></span>
                </div>
              </div>
              <h3 class="thq-heading-3">
                <div class="cssContents">
                  <span class="cssInlineBlock">{{ $t('text61') }}</span>
                </div>
              </h3>
              <div class="pricing101-text14 cssTextAlignCenter thq-body-large">
                <div class="cssContents">
                  <span class="cssInlineBlock">{{ $t('text62') }}</span>
                </div>
              </div>
            </div>
            <div class="pricing101-list1">
              <div class="pricing101-list-item">
                <svg viewBox="0 0 1024 1024" class="thq-icon-small">
                  <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                </svg>
                <span class="thq-body-small">
                  <div class="cssContents">
                    <span class="cssInlineBlock">{{ $t('text63') }}</span>
                  </div>
                </span>
              </div>
              <div class="pricing101-list-item">
                <svg viewBox="0 0 1024 1024" class="thq-icon-small">
                  <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                </svg>
                <span class="thq-body-small">
                  <div class="cssContents">
                    <span class="cssInlineBlock">{{ $t('text64') }}</span>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <button type="button" class="pricing101-button1 thq-button-outline" @click="gotoLogin">
            <span class="thq-body-small">
              <div class="cssContents">
                <span class="cssInlineBlock">{{ $t('text42') }}</span>
              </div>
            </span>
          </button>
        </div>
        <div class="pricing101-column2 thq-card">
          <div class="pricing101-price2">
            <div class="pricing101-price1">
              <div class="cssFontStyleNormal cssTextAlignCenter thq-body-large">
                <div class="cssContents">
                  <span class="cssInlineBlock"></span>
                </div>
              </div>
              <h3 class="thq-heading-3">
                <div class="cssContents">
                  <span class="cssInlineBlock">{{ $t('text65') }}</span>
                </div>
              </h3>
              <div class="pricing101-text14 cssTextAlignCenter thq-body-large">
                <div class="cssContents">
                  <span class="cssInlineBlock">{{ $t('text66') }}</span>
                </div>
              </div>
            </div>
            <div class="pricing101-list1">
              <div class="pricing101-list-item">
                <svg viewBox="0 0 1024 1024" class="thq-icon-small">
                  <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                </svg>
                <span class="thq-body-small">
                  <div class="cssContents">
                    <span class="cssInlineBlock">{{ $t('text63') }}</span>
                  </div>
                </span>
              </div>
              <div class="pricing101-list-item">
                <svg viewBox="0 0 1024 1024" class="thq-icon-small">
                  <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                </svg>
                <span class="thq-body-small">
                  <div class="cssContents">
                    <span class="cssInlineBlock">{{ $t('text67') }}</span>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <button class="pricing101-button1 thq-button-filled" @click="gotoLogin">
            <span class="thq-body-small">
              <div class="cssContents">
                <span class="cssInlineBlock">{{ $t('text42') }}</span>
              </div>
            </span>
          </button>
        </div>
      </div>
      <h2 class="cssh2">{{ $t('text68') }}</h2>
      <table class="feature-table">
        <thead>
          <tr>
            <th></th>
            <th>AutoFIT mini</th>
            <th>ZNC</th>
            <th>MNC</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ $t('text69') }}</td>
            <td></td>
            <td>✔</td>
            <td>✔</td>
          </tr>
          <tr>
            <td>{{ $t('text70') }}</td>
            <td></td>
            <td>✔</td>
            <td>✔</td>
          </tr>
          <tr>
            <td>{{ $t('text71') }}</td>
            <td></td>
            <td>✔</td>
            <td>✔</td>
          </tr>
          <tr>
            <td>{{ $t('text72') }}</td>
            <td>–</td>
            <td>✔</td>
            <td>✔</td>
          </tr>
          <tr>
            <td>{{ $t('text73') }}</td>
            <td>–</td>
            <td>–</td>
            <td>✔</td>
          </tr>
        </tbody>
      </table>

      <h2 class="cssh2">{{ $t('text74') }}</h2>
      <table class="feature-table">
        <thead>
          <tr>
            <th></th>
            <th>AutoFIT mini</th>
            <th>ZNC</th>
            <th>MNC</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ $t('text76') }}</td>
            <td>✔</td>
            <td>✔</td>
            <td>✔</td>
          </tr>
          <tr>
            <td>{{ $t('text77') }}</td>
            <td>–</td>
            <td>✔</td>
            <td>✔</td>
          </tr>
          <tr>
            <td>{{ $t('text78') }}</td>
            <td>–</td>
            <td>–</td>
            <td>✔</td>
          </tr>
          <tr>
            <td>{{ $t('text79') }}</td>
            <td>–</td>
            <td>–</td>
            <td>✔</td>
          </tr>
        </tbody>
      </table>

      <div class="faq-container">
        <h2>Frequently Asked Questions</h2>
        <p class="intro">{{ $t('text80') }}</p>

        <div class="faq-item" v-for="(faq, index) in faqs" :key="index">
          <div class="faq-question" @click="toggle(index)">
            <span>{{ $t(faq.question) }}</span>
            <span class="faq-icon">{{ activeIndex === index ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer" v-if="activeIndex === index">
            {{ $t(faq.answer) }}
          </div>
        </div>
      </div>

      <div class="contact-section">
        <h3>{{ $t('text81') }}</h3>
        <p>{{ $t('text82') }}</p>
        <button class="contact-button" @click="gotoDemo">{{ $t('text83') }}</button>
      </div>

    </div>

    <Footer/>
  </div>
</template>

<script>
import Footer from "../components/Footer.vue";

export default {
  name: 'Pricing',
  components: { Footer },
  props: {},
  data() {
    return {
      faqs: [
        {
          question: "faqs.faq1.question",
          answer: "faqs.faq1.answer"
        },
        {
          question: "faqs.faq2.question",
          answer: "faqs.faq2.answer"
        },
        {
          question: "faqs.faq3.question",
          answer: "faqs.faq3.answer"
        },
        {
          question: "faqs.faq4.question",
          answer: "faqs.faq4.answer"
        },
        {
          question: "faqs.faq5.question",
          answer: "faqs.faq5.answer"
        }
      ],
      activeIndex: null,
    }
  },
  methods: {
    toggle(index) {
      console.log("toggle");
      this.activeIndex = this.activeIndex === index ? null : index;
    },
    gotoLogin() {
      this.$router.push('/login');
    },
    gotoDemo() {
      this.$router.push('/contact');
    }
  }
}
</script>
<style scoped>

.feature-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed; /* 🔑 Zorgt voor gelijke kolombreedte */
}

.feature-table th,
.feature-table td {
  border: 1px solid #1e3a5f; /* optioneel: pas kleur aan */
  padding: 12px;
  text-align: center;
}

.feature-table th:first-child,
.feature-table td:first-child {
  text-align: left;
}

.feature-table th {
  font-weight: bold;
  background-color: #f7f7f7;
}

.feature-table td {
  vertical-align: middle;
}

.section-header td {
  font-weight: bold;
  text-align: left;
  background-color: #eef2f7;
  border: none;
}


.cssh2 {
  text-align: left !important;
}

.faq-container {
  width: 100%;
  margin: 40px auto;
  font-family: Arial, sans-serif;
  color: #222;
}

.intro {
  text-align: center;
  font-size: 16px;
  margin-bottom: 30px;
}

.faq-item {
  border: 1px solid #222;
  margin-bottom: 10px;
}

.faq-question {
  padding: 16px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

.faq-question:hover {
  background-color: #f2f2f2;
}

.faq-answer {
  padding: 30px 0 16px 16px;
  text-align: left;
  font-weight: normal;
}

.faq-icon {
  font-size: 20px;
}

.contact-section {
  text-align: center;
  margin-top: 60px;
}

.contact-section h3 {
  font-size: 24px;
  margin-bottom: 10px;
}

.contact-section p {
  margin-bottom: 20px;
  font-size: 16px;
}

.contact-button {
  padding: 12px 24px;
  background-color: #c74800;
  color: white;
  border: none;
  border-radius: 25px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
}

.contact-button:hover {
  background-color: #a33a00;
}

.textCentered {
  text-align: center;
}

.topMargin100 {
  margin-top: 100px;
}

.pricing101-pricing10 {
  width: 100%;
  height: auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  overflow: hidden;
  position: relative;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.pricing101-max-width {
  gap: var(--dl-layout-space-threeunits);
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.pricing101-section-title {
  gap: var(--dl-layout-space-unit);
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  max-width: 800px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.pricing101-content1 {
  gap: var(--dl-layout-space-oneandhalfunits);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-item-align: stretch;
  align-self: stretch;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.pricing101-content2 {
  gap: var(--dl-layout-space-twounits);
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  -ms-flex-negative: 0;
  flex-shrink: 0;
}

.pricing101-column1 {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border-color: var(--dl-color-theme-neutral-dark);
  border-style: solid;
  border-width: 1px;
  border-radius: var(--dl-layout-radius-radius4);
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  text-decoration: none;
}

.pricing101-content3 {
  gap: 32px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-item-align: stretch;
  align-self: stretch;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.pricing101-price1 {
  gap: var(--dl-layout-space-halfunit);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-item-align: stretch;
  align-self: stretch;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.pricing101-text14 {
  font-size: 48px;
  text-align: center;
}

.pricing101-column2 {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  width: auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-positive: 1;
  flex-grow: 1;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  border-color: var(--dl-color-theme-neutral-dark);
  border-style: solid;
  border-width: 1px;
  border-radius: var(--dl-layout-radius-radius4);
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  text-decoration: none;
  background-color: var(--dl-color-theme-accent1);
}

.pricing101-price2 {
  gap: 32px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-item-align: stretch;
  align-self: stretch;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}
</style>
